import { render, staticRenderFns } from "./edit-certificate.vue?vue&type=template&id=7914c36c"
import script from "./edit-certificate.vue?vue&type=script&lang=js"
export * from "./edit-certificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports